export default class ActionItem {
    constructor(action,actionKey,isIdleAction,weight){
        this.actionKey=actionKey
        this.action=action
        this.isIdleAction=isIdleAction?isIdleAction:false
        this.weight=weight | 0
        this.playTime=0
    }
    pauseAction(){
        if(this.action){
            this.action.paused=true
        }
    }
    unPauseAction(){
        if(this.action){
            this.action.paused=false
        }
    }
    updateWeight(){
        if(this.action){
            this.weight = this.action.getEffectiveWeight()
        }
        
    }
    updatePlayTime(time){
        this.playTime = time || Date.now() 
    }
    release(){
        
    }
}


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/action/actionItem.js